/**
 * ProjectManagementPage Component
 * AIDLC Administrative Backend
 *
 * Main page with master-detail layout:
 *   - Left panel (280px): ProjectList
 *   - Right panel: ProjectDetail with tabs
 *
 * Route: /projects
 */

import { useState, useCallback } from 'react';
import { ProjectList } from './ProjectList';
import { ProjectDetail } from './ProjectDetail';
import type { ProjectOverview } from '../../types/projects';

export function ProjectManagementPage() {
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);

  const handleSelectProject = useCallback((project: ProjectOverview) => {
    setSelectedProjectId(project.id);
  }, []);

  return (
    <div className="flex h-[calc(100vh-64px)] -m-6">
      {/* Left panel: Project list */}
      <div className="w-[280px] flex-shrink-0 border-r border-zinc-200 bg-white dark:bg-zinc-900 dark:border-zinc-800 overflow-hidden">
        <ProjectList
          selectedProjectId={selectedProjectId}
          onSelectProject={handleSelectProject}
        />
      </div>

      {/* Right panel: Project detail */}
      <div className="flex-1 min-w-0 overflow-hidden">
        {selectedProjectId ? (
          <ProjectDetail projectId={selectedProjectId} />
        ) : (
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                </svg>
              </div>
              <h3 className="text-sm font-semibold text-gray-700">Select a project</h3>
              <p className="text-xs text-gray-400 mt-1">Choose a project from the list to view details.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
